import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsys.widget.pdfviewer');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsys-widget-pdfviewer',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsys.widget.pdfviewer/view.scss */
:host {
  display: block;
}`],
})
export class PortalLpsysWidgetPdfviewerComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() url: string = '';

    public loading: boolean = true;
    public error: boolean = false;
    public images: string[] = [];

    public async ngOnInit() {
        await this.service.init();
        await this.loadPDF();
    }

    public async loadPDF() {
        this.loading = true;
        this.error = false;
        this.images = [];
        await this.service.render();

        try {
            const res = await wiz.call("pages", { url: this.url });
            if (res.code === 200 && res.data.images) {
                this.images = res.data.images;
            } else {
                this.error = true;
            }
        } catch (e) {
            console.error('PDF load error:', e);
            this.error = true;
        }

        this.loading = false;
        await this.service.render();
    }

    public downloadFile() {
        const a = document.createElement('a');
        a.href = this.url + '?download=1';
        a.target = '_blank';
        a.click();
    }
}

export default PortalLpsysWidgetPdfviewerComponent;